// extracted by mini-css-extract-plugin
export default {"title":"naa-z","warning":"oaa-z","sizeOptionsLegendText":"paa-z"};